import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import {
  UPDATE_WORKSPACE_TEXT_EDITOR_CONTENT,
  UPDATE_COMPANY_TEXT_EDITOR_CONTENT,
} from "../../graphql/mutations/WidgetsContext";

// eslint-disable-next-line import/prefer-default-export
export const useUpdateTextEditor = ({ isOverview, siteId, textKey }) => {
  const [updateWorkspaceText] = useMutation(
    UPDATE_WORKSPACE_TEXT_EDITOR_CONTENT
  );
  const [updateCompanyText] = useMutation(UPDATE_COMPANY_TEXT_EDITOR_CONTENT);

  const handleSaveWorkspaceContent = async newContent => {
    try {
      const res = await updateWorkspaceText({
        variables: {
          siteId,
          textkey: textKey,
          culture: "sv-SE",
          contents: newContent,
        },
      });
      if (
        res &&
        res.data &&
        res.data.widgetsContext &&
        res.data.widgetsContext.updateWorkspaceTextEditorContent
      ) {
        const {
          success,
        } = res.data.widgetsContext.updateWorkspaceTextEditorContent;
        if (success) {
          return true;
        }
        return false;
      }
    } catch (err) {
      console.error("error >", err);
    }
  };

  const handleSaveCompanyContent = async newContent => {
    try {
      const res = await updateCompanyText({
        variables: {
          siteId,
          textkey: textKey,
          culture: "sv-SE",
          contents: newContent,
        },
      });
      if (
        res &&
        res.data &&
        res.data.widgetsContext &&
        res.data.widgetsContext.updateCompanyTextEditorContent
      ) {
        const {
          success,
        } = res.data.widgetsContext.updateCompanyTextEditorContent;
        if (success) {
          return true;
        }
        return false;
      }
    } catch (err) {
      console.error("error >", err);
    }
  };

  const updateTextEditor = newContent => {
    if (isOverview) {
      return handleSaveCompanyContent(newContent);
    }
    return handleSaveWorkspaceContent(newContent);
  };

  return { execute: updateTextEditor };
};
